import { Component } from '@angular/core';
import { TranslationService } from '../../translations';

@Component({
    selector: 'pi-forbidden-page',
    templateUrl: './forbidden-page.component.html',
    styleUrls: ['./forbidden-page.component.less'],
    standalone: false
})
export class ForbiddenPage {
    constructor(public TR: TranslationService) {}
}
